import { connect } from 'react-redux';
import { actionGetLocationList } from 'store/location/actions';
import { actionGetMarketList } from 'store/market/actions';
import {
  ADD_PLACE_FAVORITE,
  DELETE_PLACE_FAVORITE,
} from 'store/place/actionTypes';

import FavoritePlace from './FavoritePlace';

const mapStateToProps = (state) => ({
  isLoadingLocationList: state.Location.isLoadingLocationList,
  isLoadingMarketList: state.Market.isLoadingMarketList,
  locationList: state.Location.locationList,
  totalLocation: state.Location.totalLocation,
  marketList: state.Market.marketList,
  marketTotal: state.Market.marketTotal,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetLocationList: (payload) => dispatch(actionGetLocationList(payload)),
  actionGetMarketList: (payload) => dispatch(actionGetMarketList(payload)),
  actionAddPlaceFavorite: (payload) =>
    dispatch({ type: ADD_PLACE_FAVORITE, payload }),
  actionDeletePlaceFavorite: (payload) =>
    dispatch({ type: DELETE_PLACE_FAVORITE, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(FavoritePlace);
